enum UserEmailMinNotificationLevel {
    OFF = 'off',
    HIGH = 'high',
    NORMAL = 'normal',
    LOW = 'low',
    ONLY_INVOICES = 'only_invoices',
}

export default UserEmailMinNotificationLevel;
